<template>
  <div class="campaign-page">
    <top-bar
      activeTab="campaign"
      :lbl="lbl"
      :profile="profile"
      :isLogin="isLogin"
      @switchLang="switchLang($event)"
      @logout="logout()"
    >
    </top-bar>
    <p class="section-head">รายการแคมเปญของฉัน</p>
    <campaign-list
      v-if="isLoaded"
      :lbl="lbl"
      :isLoading="isLoading"
      :initListConfig="listConfig"
      :initFilterConfig="filterConfig"
      :busEvent="busCampaign"
      @clickUnSubScribe="clickUnSubScribe($event)"
      @clickCampaign="clickCampaign($event)"
      @toggleLoading="toggleLoading($event)"
    >
    </campaign-list>

    <!-- <div class="wrapper-campaign-list">
            <div v-if="isLoaded && isHaveItem" class="box-campaign-list">
                <div
                    v-for="(campaign, k) in campaigns"
                    :key="k"
                    :index="k"
                >
                    <div class="campaign-item"
                    :class="{'disable': campaign.redeemItem && campaign.redeemItem.IsUsed}"
                    v-on:click="clickCampaign(campaign)">
                        <div class="campaign-image">
                            <img src="@/assets/img/icon_cahnel.png" />
                        </div>
                    <div class="description">
                        <div class="campaign-date">ใช้ได้ถึง: {{toDate(campaign.expireDate)}} </div>
                        <div>{{campaign.name}}</div>
                    </div>
                    </div>
                </div>


            <div class="footer-campaign-list empty-footer-campaign-list"> <p class="text-sub-head c-red" @click="clickUnSubScribe()"><u>ยกเลิกการรับข้อมูลข่าวสาร ?</u></p> </div>
            </div>

            <div v-else class="box-campaign-list">
                <div class="empty-campaign-list">
                    <div class="empty-logo">
                    <img src="@/assets/img/icon_cahnel.png" />
                    <p >ไม่พบแคมเปญของคุณ</p>
                    </div>

                </div>
                <div class="footer-campaign-list empty-footer-campaign-list" id="blank-campaign"> <p class="text-sub-head c-red" @click="clickUnSubScribe()"><u>ยกเลิกการรับข้อมูลข่าวสาร ?</u></p> </div>
            </div>
        </div> -->

    <modal
      view="campaign-list"
      :busModal="busModal"
      @modalConfirmOk="clickConfirm"
      @modalConfirmCancel="clickCancel"
    ></modal>
    <modal-delete-account
      :busModal="busModalDeleteAccount"
      @hideModal="clickCloseLine"
    ></modal-delete-account>
    <modal-error :busModal="busModalError"></modal-error>

    <serial-modal
      :lbl="lbl"
      :isLogin="isLogin"
      :busSerialModal="busSerialModal"
    ></serial-modal>
  </div>
</template>
<script>
import Vue from "vue";

import Account from "@/helper/AccountHelper.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
import Locale from "@/helper/locale/locale.js";
import Moment from "moment";

import TopBar from "@/components/TopBar.vue";
import Modal from "@/components/modal/Modal.vue";
import ModalDeleteAccount from "@/components/modal/ModalDeleteAccount.vue";
import ModalError from "@/components/modal/ModalError.vue";

import CampaignList from "@/components/campaign/list/CampaignList.vue";
import {
  CampaignListConfigBuilder,
  CampaignListFilterConfigBuilder,
} from "@/service/config/CampaignConfigModel.js";

import BzbsHistory from "@/service/BzbsHistory.js";
import {
  PurchaseListConfigBuilder,
  PurchaseFilterConfigBuilder,
} from "@/service/config/HistoryConfigModel.js";

import SerialModal from "@/components/modal/SerialModal.vue";
import BzbsApi from "@/service/BzbsApi.js";
import BzbsAuth from "@/service/BzbsAuth.js";
import { TrackingService } from "@/helper/TrackingHelper.js";


export default {
  name: "Campaign",
  components: {
    TopBar,
    Modal,
    ModalDeleteAccount,
    SerialModal,
    CampaignList,
    ModalError,
  },
  data: function () {
    return {
      isLogin: false,
      user: {},
      profile: {},
      lbl: Locale.getLbl(),
      locale: Locale.getLocaleCode(),

      isLoaded: false,
      isLoading: false,
      isHaveItem: true,
      campaignId: "",
      campaign: null,
      campaignConfig: null,

      campaigns: [],
      campaignListConfig: null,
      listConfig: {},
      filterConfig: {},

      purchaseListConfig: {},
      purchaseFilterListConfig: {},
      busHistory: new Vue(),

      busModal: new Vue(),
      busModalDeleteAccount: new Vue(),
      busSerialModal: new Vue(),
      busCampaign: new Vue(),
      busModalError: new Vue(),
      testToken: Account.getToken(),

      tracking: new TrackingService(this),
      serialCampaign: {},
    };
  },
  created: function () {
        this.tracking.screenName("campaign_list");
        this.tracking.event("campaign_list", "view_campaign_list");

    Account.loginStatus().then((status) => {
      this.isLogin = status;
      this.user = Account.getCacheUser();
      this.profile = Account.getCacheProfile();
    });

    //this.initialConfig();
    this.addUserByTag()
      .then(() => {
        this.onResume()
          .then(() => {
            this.initialConfig();
          })
          .catch(() => {
            this.initialConfig();
          });
      })
      .catch(() => {
        this.initialConfig();
      });
    // this.getList();
    // this.initialConfig();
    // this.getHistory();
  },
  mounted: function () {
    this.tester();
    Account.loginStatus().then((status) => {
      if (!status) {
        this.$router.push("/register");
      }
    });
  },

  methods: {
    onResume: function () {
      var strBzbsToken = Account.getToken();
      return new Promise((resolve, reject) => {
        BzbsAuth.apiResume(strBzbsToken)
          .then((data) => {
            Account.updateToken(data.data.token);
            this.user = Account.getCacheUser();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    initialConfig: function () {
      var listConfig = new CampaignListConfigBuilder()
        .setConfigList("campaign_chanelfashion")
        .setTop(10)
        .create();
      this.listConfig = listConfig;

      var filterConfig = new CampaignListFilterConfigBuilder().create();
      this.filterConfig = filterConfig;
      this.isLoaded = true;
    },
    tester: function () {
      var param = this.$route.query;
      switch (param.tester) {
        case "confirm-delete-account":
          this.busModal.$emit("showConfirmModal", {
            title: "ลบบัญชีผู้ใช้",
            message: "คุณต้องการลบบัญชีผู้ใช้<br>Chanel Beauty TH  ใช่หรือไม่",
            strBtnOk: "ยืนยัน",
            strBtnCancel: "ยกเลิก",
            tag: "confirm-delete",
          });
          break;
      }
    },

    getList: function () {
      var strBzbsToken = Account.getToken();
      BzbsCampaign.apiGetCampaign(strBzbsToken, this.campaignListConfig, null)
        .then((campaignResult) => {
          //this.campaigns = [];
          for (var campaign of campaignResult) {
            //TODO: Add GA Tracking.
            this.campaigns.push(campaign);
          }

          this.isLoaded = true;
          this.isHaveItem = this.campaigns.length > 0 ? true : false;
        })
        .catch((error) => {
          this.isLoaded = true;
          this.isHaveItem = false;
          console.log(error);
        });
    },
    getHistory: function () {
      //initial config for api.
      var token = Account.getToken();
      var listConfig = new PurchaseListConfigBuilder()
        .setConfigList(Vue.bzbsConfig.mainConfig.purchaseListConfig)
        .create();
      this.purchaseListConfig = listConfig;

      //initial filter config for api.
      var filterListConfig = new PurchaseFilterConfigBuilder().create();
      this.purchaseFilterListConfig = filterListConfig;

      BzbsHistory.apiGetPurchase(
        token,
        this.purchaseListConfig,
        this.filterConfig
      )
        .then((purchases) => {
          console.log(purchases);
          // this.purchaseListConfig.intSkip += this.purchaseListConfig.defaultTopAmount;
          // //check is there are more campaign.
          // if (purchases &&
          //     purchases.length < this.purchaseListConfig.defaultTopAmount)
          //     this.purchaseListConfig.isSeeMoreEnable = false;
          // //reinitialize list if no skip.
          // if (this.purchaseListConfig.intSkip == this.purchaseListConfig.defaultTopAmount)
          //     this.purchases = [];

          // for (var purchase of purchases) {
          //     //TODO: Add GA Tracking.
          //     this.purchases.push(purchase);
          // }

          // this.isLoaded = true;
          // this.isHaveItem = this.purchases.length > 0
          //     ? true
          //     : false;

          // this.toggleLoading(false);
        })
        .catch((error) => {
          this.isLoaded = true;
          // this.isHaveItem = false;
          this.toggleLoading(false);
          console.log(error);
        });
    },
    getCampaign: function () {
      var strBzbsToken = Account.getToken();
      strBzbsToken = this.testToken;
      BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig)
        .then((result) => {
          this.campaign = result;
          this.isLoaded = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toDate: function (campaignDate) {
      return Moment.unix(campaignDate).format("YYYY-MM hh:mm");
    },
    toggleLoading: function (isLoading) {
      this.isLoading = isLoading;
    },
    switchLang: function (locale) {
      Locale.setLocale(locale);
      this.lbl = Locale.getLbl();
    },
    logout: function () {
      Account.setLogout();
      this.isLogin = false;
      this.profile = {};
    },
    clickUnSubScribe: function () {
      this.busModal.$emit("showConfirmModal", {
        title: "ลบบัญชีผู้ใช้",
        message:
          "คุณต้องการลบบัญชีผู้ใช้<br>CHANEL BEAUTY <br> ใช่หรือไม่",
        strBtnOk: "ยืนยัน",
        strBtnCancel: "ยกเลิก",
        tag: "confirm-delete",
      });
    },
    clickConfirm: function (objConfirm) {
      this.tracking.event("Unregis_flow", "click_confirm_unregis_botton");
      switch (objConfirm.tag) {
        case "confirm-delete":
          Account.apiUnSubScribe()
            .then((objResult) => {
              if (objResult.data && objResult.data.success) {
                Account.removeCacheUser();
                this.busModalDeleteAccount.$emit("showModal");
              } else {
                console.log(objResult);
              }
            })
            .catch((error) => {
              if (error.response) {
                console.log(error.response.data);
                this.busModalError.$emit("showModal");
              } else {
                this.busModal.$emit(
                  "showAlertModal",
                  this.$configModalNoConnect
                );
              }
            });

          break;
      }
    },
    clickCancel: function () {
      this.tracking.event("Unregis_flow", "click_unconfirm_unregis_botton");
    },
    clickCloseLine: function () {
      window.lineFunction.closewindow();
    },
    //event
    clickCampaign: function (campaign) {
      //GA

      this.tracking.event("campaign_list", "click_campaign", campaign.id+"|"+campaign.name);

      if (!campaign.redeemItem) {
        var path = "/detail/" + campaign.id;
        this.$router.push(path);
      } else {
        if (!campaign.redeemItem.IsUsed) {

          this.tracking.screenName("campaign_list");
          this.tracking.event("campaign_detail", "view_code_campaign", campaign.id+"|"+campaign.name);
          this.initialSerialModal(campaign);
        } else {
          return;
        }
      }
    },
    //method
    isSoldOut: function () {
      return this.campaign.qty < 1 ? true : false;
    },
    //utility
    getPointMessage: function () {
      var pointType =
        this.campaign.pointType == "get"
          ? this.lblCampaign.get_point
          : this.lblCampaign.use_point;
      var pointUnit =
        this.lblCampaign.point +
        (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033
          ? "s"
          : "");
      return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
    },
    initialSerialModal: function (campaign) {
      this.serialCampaign = campaign;
      this.serialCampaign.serial = campaign.redeemItem.Serial;
      this.busSerialModal.$emit("showSerialModal", this.serialCampaign);
    },
    addUserByTag: function () {
      var tag = Account.getCacheCustom("tag");
      var strBzbsToken = Account.getToken();
      return new Promise((resolve, reject) => {
        if (tag) {
          var params = {};
          params.tag = tag;

          var strUrl = Vue.bzbsConfig.newBzbsModuleUrl + "/campaign/tag";
          BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params)
            .then((response) => {
              Account.removeCacheCustom("tag");
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          reject();
        }
      });
      // if (tag) {

      //     var params = {};
      //     params.tag = tag;

      //     var strUrl = Vue.bzbsConfig.bzbsUrl+ "/modules/chanel/campaign/tag";
      //     return new Promise(() => {

      //         BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).then((response) => {

      //            console.log(response);

      //             }).catch((error) => {
      //                 console.log(error);
      //             });

      //         });

      // }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/page/Campaign.scss";
.campaign-item {
  padding-top: 0px;
  align-self: start;
  justify-content: start;
  img {
    margin-top: 6px;
    width: 41px;
    height: 31px;
  }
}

.disable {
  opacity: 0.5;
}

.description {
  margin-left: 30px;
  line-height: 1.5;
  font-weight: bold;
}
</style>

